import { useDispatch, useSelector } from "react-redux";
import { selectMessage, selectShowMessage, selectStyle, setMessage, setShowMessage } from "./SignalRAlertSlice";
import { OKAlert } from "cpl-react-common/components/Alerts/Okay";

export const SignalRAlert: React.FC = () => {
  const dispatch = useDispatch();
  const message = useSelector(selectMessage);
  const style = useSelector(selectStyle);
  const showMessage = useSelector(selectShowMessage);

  function dismissMessage() {
    dispatch(setMessage(""));
    dispatch(setShowMessage(false));
  }

  return (
    <OKAlert
      showAlert={showMessage}
      alertText={message}
      alertTitle="Notification"
      callBack={dismissMessage}
      style={style}
    />
  );
};
